// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191042/js/" + chunkId + "." + {"44":"f56e72e4","225":"f3aaf834","481":"cd04514f","486":"e2a67662","770":"8940dceb"}[chunkId] + ".0.36053042800559354.chunk.js";
};